<glxy-page [isLoading]="isLoading()">
  <glxy-page-toolbar>
    <glxy-page-title>{{ 'INBOX.SETTINGS.WEBCHAT_CONFIGURATION' | translate }}</glxy-page-title>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="isBusinessApp ? 'full' : 'narrow'">
    <inbox-webchat-form
      [webChatForm]="webChatForm"
      [knowledgeForm]="knowledgeForm"
      [backUrl]="backUrl"
      [submitCTA]="'INBOX.NEXT' | translate"
      (submitting)="creatingWebChat($event)"
    ></inbox-webchat-form>
  </glxy-page-wrapper>
</glxy-page>
